import { render, staticRenderFns } from "./EditAnnotation.vue?vue&type=template&id=1d92fbe4&scoped=true&"
import script from "./EditAnnotation.vue?vue&type=script&lang=js&"
export * from "./EditAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./EditAnnotation.vue?vue&type=style&index=0&id=1d92fbe4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d92fbe4",
  null
  
)

export default component.exports